import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/h5txNPzEAWehycAvkdsw7M/Mockup_-_SN11_(1x1).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-64" data-mp="4lyv8luf2edn">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-65" data-mp="1297a3xzwwp6o" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-66" data-mp="xae5yw6imaj6">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl mt-[-45px] mb-[-10px]" data-id="element-67" data-mp="xb5s7ge82vws">
          🌿BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display font-bold text-white sm:text-5xl lg:text-6xl text-[19px]" data-id="element-68" data-mp="381xmf1kmf8br">
          Recuperá los momentos “ON” de tu familiar en 21 días{' '}
          <span className="text-brand-light" data-id="element-69" data-mp="3e8ecex8c4zyo">
            organizando lo que come, cuándo lo come y cómo se mueve.
          </span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-70" data-mp="358rckfv9827q">
          <img src={mockupUrl} alt="Mockup del Protocolo Parkinson Bajo Control" width="1024" height="1024" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-71" data-mp="2hjf6vpz4yca6" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-72" data-mp="nb1o3ec0ka16">
          <p className="font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl mb-[-8px]" data-id="element-73" data-mp="1b1ffd2mry4up">
            PROTOCOLO — PARKINSON BAJO CONTROL™
          </p>
          <p className="mt-3 text-sm leading-relaxed text-slate-200 sm:text-base mb-[-19px]" data-id="element-74" data-mp="112px38qyuidx">
            El primer sistema práctico para cuidadores argentinos que ya
            probaron de todo y siguen viendo cómo la pastilla tarda horas en
            hacer efecto o deja de funcionar de repente.
          </p>
          <div className="mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm mb-[-21px]" data-id="element-75" data-mp="3hrlp6vpyqvfb">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-76" data-mp="1xacer0y0hfs6">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-77" data-mp="21bfxpwbcvrxm" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="268obzltdvbtl">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-79" data-mp="2fzsu2uecvcsn" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-80" data-mp="2kxuebinipi5p">
          <ActionButton href="#pricing" showTrust data-id="element-81" data-mp="unj05c5iusld">
            QUIERO MI SISTEMA AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}